import React, { useState} from "react";
import { Modal, Form } from "antd";
import useFetch from "../../commons/useFetch";
function EndowModal({ setEndowModal, endowModal}) {
    const [endow, setEndow] = useState();
    const { data: endows } = useFetch('https://610ec1597f793c00174195b7.mockapi.io/api/endows')
    const handleCancel = () => {
        setEndowModal(false)
        setEndow('')
    }
    const handleEndow=(e)=>{
        setEndow(e)
    }
    return (
        <div className="modalBox ">
            <Modal
                title="CHỌN CHƯƠNG TRÌNH ƯU ĐÃI"
                className="endowModal modalStyle"
                visible={endowModal}
                onCancel={handleCancel}
                footer={null}
            >
                <Form>
                    <div className="widgetContent">
                        {endows.map(item=>{
                            return(
                                <div className={endow === item.id ? "optionSelect optionChoose" :"optionSelect"} onClick={(e)=>handleEndow(item.id)}>
                                    <div className="percent">{item.precent}</div>
                                    <div className="content">
                                        <div className="headContent">{item.name}</div>
                                        <div className="expiryDate">Đặt từ {item.start_date} đến {item.end_date}</div>
                                        <div className="expiryDate">Lưu trữ từ {item.start_date} đến {item.end_date}</div>
                                    </div>
                                </div>
                            )
                        })}
                        
                    </div>
                    <Form.Item className="btnModal">
                        <button className="btnStyle" >
                            Áp dụng
                        </button>
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
}
export default EndowModal;
